import { makeCreateEvoClient } from "../shared/createEvoClient";

import { createClient, createConfig } from "./__generated__/client";

export type { EvoClientParams } from "../shared/createEvoClient";
export { X_BRAND_HEADER, X_DES_ORG_BRAND_HEADER } from "../shared/createEvoClient";
export { sanitizeBaseUrl } from "../shared/sanitizeBaseUrl";
export * from "./__generated__";

export const createEvoClient = makeCreateEvoClient({ createClient, createConfig });
